module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._v("\n\tDISPLAY\n")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4fe17c01"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Transactions/MySubscriptions/Display.vue
// module id = 1131
// module chunks = 0